/**
 * KYC Service Implementation
 * Handles KYC check operations for post-SDK verification
 */

import type { AxiosInstance } from "axios";
import type { RequestConfig } from "../types/common";

export interface KycCheckRequest {
	digitalProfileID: string;
}

export interface KycCheckResponse {
	isStepUpRequired: boolean;
	isAllowedToProceed: boolean;
	isReviewPending: boolean;
}

export interface InitiateKycCheckRequest {
	applicant_id: string;
	document_ids: string[];
	digital_profile_id: string;
}

export class KycService {
	constructor(private readonly httpClient: AxiosInstance) {}

	async getKycCheckStatus(
		request: KycCheckRequest,
		config?: RequestConfig,
	): Promise<KycCheckResponse> {
		const response = await this.httpClient.get(
			"/profile/compliance/kyc-checks",
			{
				params: {
					digitalProfileId: request.digitalProfileID,
				},
				...config,
			},
		);
		return response.data;
	}

	async initiateKycCheck(
		request: InitiateKycCheckRequest,
		config?: RequestConfig,
	): Promise<void> {
		const response = await this.httpClient.post(
			"/profile/compliance/kyc-checks",
			request,
			config,
		);

		// Only treat 201 as success
		if (response.status !== 201 && response.status !== 200) {
			throw new Error(`Expected 20X Created, but received ${response.status}`);
		}
	}
}
